import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import OnePageCheckoutData, {
    OnePageCheckoutCreateAccountState,
    OnePageCheckoutTabState,
} from "@sunSource/Store/Data/NewOnePageCheckout/OnePageCheckoutDataState";
import { Draft } from "immer";

const initialState: OnePageCheckoutData = {
    tabState: {
        openTabs: [0],
        completedTabs: [],
        currentTab: 0,
    },
    createAccountState: {
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        jobTitle: "",
        companyName: "",
        businessType: "",
        addressLineOne: "",
        addressLineTwo: "",
        city: "",
        state: "",
        zipCode: "",
        customerNumber: "",
        fax: "",
        password: "",
        formType: "",
        country: "",
        billToCountry: "",
        billToAddressLineOne: "",
        billToAddressLineTwo: "",
        billToCity: "",
        billToState: "",
        billToZipCode: "",
        IsShipToSameAsBilling: true,
        isSubscribed: false,
        tempoData:{
            savedService: "",
            orderNotes: "",
            editDeliveryMethod: false
        }
    },
};

const reducer = {
    "Pages/OnePageCheckout/TabState": (
        draft: Draft<OnePageCheckoutData>,
        action: { onePageCheckoutTabData: OnePageCheckoutTabState },
    ) => {
        draft.tabState = action.onePageCheckoutTabData;
    },
    "Pages/OnePageCheckout/CreateAccount": (
        draft: Draft<OnePageCheckoutData>,
        action: { onePageCheckoutCreateAccountData: Partial<OnePageCheckoutCreateAccountState> },
    ) => {
        draft.createAccountState = {
            ...draft.createAccountState,
            ...action.onePageCheckoutCreateAccountData,
        };
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
